import AOS from 'aos';
import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from './breakpoints';

const selectors = {
  mainCarousel: '[data-splide-carousel]',
};

const initCarousel = (el, options = {}, replaceOptions = false) => {
  const carousel = el.querySelector(selectors.mainCarousel);
  let carouselOptions = {};

  if (carousel) {
    carouselOptions = {
      perPage: 2,
      perMove: 1,
      gap: '1rem',
      pagination: false,
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.md]: {
          perPage: 3,
        },
        [unitlessBreakpoints.lg]: {
          perPage: 4,
        },
      },
      ...options,
    };

    if (replaceOptions) {
      carouselOptions = options;
    }

    const splide = new Splide(carousel, carouselOptions).mount();
    const arrowsEl = carousel.querySelector('.splide__arrows');

    const syncArrowsHiddenClass = () => {
      if (!arrowsEl) {
        return;
      }
      const { perPage } = splide.options;
      const shouldHide =
        typeof perPage === 'number' && splide.length <= perPage;

      if (shouldHide) {
        arrowsEl.setAttribute('data-arrows-hidden', '');
      } else {
        arrowsEl.removeAttribute('data-arrows-hidden');
      }
    };

    if (splide.length <= splide.options.perPage) {
      splide.options = {
        arrows: false,
      };
    }

    syncArrowsHiddenClass();
    splide.on('updated', syncArrowsHiddenClass);

    splide.on('hidden', () => {
      if (splide.length > splide.options.perPage) {
        splide.options = {
          arrows: true,
        };
      }
      syncArrowsHiddenClass();
    });

    splide.on('visible', () => {
      if (splide.length <= splide.options.perPage) {
        splide.options = {
          arrows: false,
        };
      }
      syncArrowsHiddenClass();
    });

    AOS.refresh();
    return splide;
  }

  return null;
};

export default initCarousel;
